import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreatePostRequest,
  DeletePostRequest,
  SearchPostsRequest,
  UpdatePostRequest,
  ViewPostHierarchyRequest,
  ViewPostsRequest
} from './post.types';

export const requestCreatePost = createAction<SagaPayload<CreatePostRequest>['payload']>('request/createPost');

export const requestViewPosts = createAction<SagaPayload<ViewPostsRequest>['payload']>('request/viewPosts');

export const requestUpdatePost = createAction<SagaPayload<UpdatePostRequest>['payload']>('request/updatePost');

export const requestDeletePost = createAction<SagaPayload<DeletePostRequest>['payload']>('request/deletePost');

export const requestSearchPosts = createAction<SagaPayload<SearchPostsRequest>['payload']>('request/searchPosts');

export const requestViewPostHierarchy =
  createAction<SagaPayload<ViewPostHierarchyRequest>['payload']>('request/viewPostHierarchy');
